import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import QrCode from "../QrCode";

import { styles } from "./styles";

interface QrCardProps {
  invoiceUrl: string;
  name?: string;
}

const QrCard = React.forwardRef<HTMLDivElement, QrCardProps>((props, ref) => {
  const { invoiceUrl, name } = props;

  return (
    <Box ref={ref} sx={styles.cardContainer}>
      <Box sx={styles.cardContent}>
        <Typography color="grey000">
          Оплата за реквізитами
          {name && (
            <Typography
              data-testid="qr-card-name"
              component="span"
              color="grey000"
              sx={{
                fontWeight: 700,
                display: "block",
                wordBreak: "break-word",
              }}
            >
              {name}
            </Typography>
          )}
        </Typography>

        <QrCode invoiceUrl={invoiceUrl} />
        <Typography>Скануйте камерою телефону</Typography>
      </Box>
    </Box>
  );
});

QrCard.displayName = "QrCard";

export default QrCard;
